import { render } from "./AdminTasksWorkflow.vue?vue&type=template&id=3f2fd0ae"
import script from "./AdminTasksWorkflow.vue?vue&type=script&lang=js"
export * from "./AdminTasksWorkflow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__